// extracted by mini-css-extract-plugin
export default {"title":"_2c3993a29c","bld":"a966e3a2a1"};